// The club card (snippets/raiders-card.liquid, snippets/gsge-card.liquid): a piece, its colour where it
// comes in more than one, its size, a mark per side, how many — on a club's private order page and on
// the piece's own product page. Loaded by those sections as an asset, since the theme only runs a
// section's own script block on pages where that section sits.
// The form: a size and at least one design before anything is added; then the cart drawer, like the
// product page. Each side (front, back) holds its own choice; the pictures follow the piece, the colour,
// the marks and the spot, and the next picture is fetched before it is shown so a flip doesn't wait.
// Both cards are built the same way (Justis, 20 Sep: no drift between the company pages): a spot chooser
// on the front (centre chest / small on the left chest), and every tile says which class it is
// (data-class chest or centre) — the Raiders heads and the GS monogram are chest marks, the crests and
// the wordmarks centre marks — so the spot fades the tiles that don't go there. The GSGE card adds a
// colour chooser: a tile carries its ink (data-ink B bronze, W white, K black) and only the inks that
// print on the chosen colour show (bronze on both, white on black, black on white). A back tile can be
// an overlay instead of a picture (data-rir-overlay: the Raiders name and number) — drawn over the
// plain back where the print sits, from the piece's data-nnbox. On the Hive page a card is a real
// store to try (data-rir-demo-wrap): everything works but the add to cart, which says so instead.
(function () {
  var forms = document.querySelectorAll('[data-rir-form]');
  if (!forms.length) return;
  forms.forEach(function (form) {
    form.noValidate = true;
    var add = form.querySelector('[data-rir-add]');
    if (add) add.disabled = false;
  });

  function nudge(el) {
    if (!el) return;
    el.classList.add('is-nudge');
    setTimeout(function () { el.classList.remove('is-nudge'); }, 900);
    el.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(s) { return Number(String(s || '').replace(/[^0-9.]/g, '')) || 0; }
  // a difference of two prices, in whole cents (25.88 to 40.88 is $15, not $15.000000000000004), shown without a .00
  function dollars(n) { var c = Math.round(n * 100); return c % 100 ? (c / 100).toFixed(2) : String(c / 100); }

  function media(card) {
    if (card._rirMedia) return card._rirMedia;
    var el = card.querySelector('[data-rir-media]');
    try { card._rirMedia = el ? JSON.parse(el.textContent) : {}; } catch (err) { card._rirMedia = {}; }
    return card._rirMedia;
  }
  function piece(card) {
    var on = card.querySelector('[data-rir-piece]:checked');
    if (on) return on.value;
    var sizes = card.querySelector('[data-rir-sizes]');
    return sizes ? sizes.getAttribute('data-piece') : null;
  }
  // the colour, on a card that offers one (the GSGE card); null on the Raiders card (black only)
  function colourOf(card) {
    var c = card.querySelector('[data-rir-colour]:checked');
    return c ? c.value : null;
  }
  function sizesOf(card) {
    var col = colourOf(card);
    var sel = '[data-rir-sizes][data-piece="' + piece(card) + '"]' + (col ? '[data-colour="' + col + '"]' : '');
    return card.querySelector(sel) || card.querySelector('[data-rir-sizes][data-piece="' + piece(card) + '"]') || card.querySelector('[data-rir-sizes]');
  }
  function on(card, name) { return card.querySelector('input[name="' + name + '-' + card.id + '"]:checked'); }
  function label(radio) { return radio ? (radio.getAttribute('data-label') || '') : ''; }
  function hasSpot(card) { return !!card.querySelector('[data-rir-spot]'); }
  // a tile's class: chest (small on the left chest) or centre
  // 'shoulder' is River Kings' and Infinity's name for the same thing the Raiders call 'chest':
  // a small mark that only goes on one side of the front. Without this they read as centre marks,
  // so they showed up under Center chest and the Left chest spot had nothing it would enable.
  function classOf(radio) {
    var c = radio && radio.getAttribute('data-class');
    return (c === 'chest' || c === 'shoulder') ? 'chest' : 'centre';
  }
  // the back tile chosen, when it is an overlay (nn, info) rather than a picture
  function overlayOf(card, code) {
    if (!code) return '';
    var r = card.querySelector('input[name="back-' + card.id + '"][value="' + code + '"]');
    var tile = r && r.closest('[data-rir-overlay]');
    return tile ? tile.getAttribute('data-rir-overlay') : '';
  }
  // the front's spot: centre chest, or small on the left chest — a piece whose front takes the chest marks
  // only (the zip hoodies) is the left chest; a card without a chooser takes it from the chosen tile's class
  function spotOf(card) {
    var fs = sizesOf(card);
    if (fs && fs.getAttribute('data-front-only')) return 'chest';
    if (!hasSpot(card)) {
      return classOf(on(card, 'front'));
    }
    var s = on(card, 'spot');
    return s ? s.value : 'centre';
  }
  function side(card) { return card._rirSide || 'front'; }

  // pictures: the 900 wide one for the big picture, 300 for the side tabs; fetched ahead, swapped once loaded
  function at(url, w) { return url ? url.replace(/width=900/, 'width=' + w) : url; }
  var warmed = {};
  function warm(url) {
    if (!url || warmed[url]) return;
    warmed[url] = 1;
    var i = new Image(); i.src = url;
  }
  function show(img, url, alt) {
    if (!img) return;
    // the description follows the choice straight away, so a screen reader never hears a mark that is
    // no longer on the picture, even while the new picture is still loading
    if (alt != null) img.setAttribute('alt', alt);
    if (!url || img._rirWant === url) return;
    if (img.getAttribute('src') === url) { img._rirWant = url; return; }
    img._rirWant = url;
    var pre = new Image();
    pre.onload = function () { if (img._rirWant !== url) return; img.removeAttribute('srcset'); img.src = url; };
    pre.onerror = function () { if (img._rirWant === url) img._rirWant = null; };
    pre.src = url;
  }
  // what the picture now shows, in words: the piece, its colour, the mark on the side you are looking at
  function described(card, sd) {
    var name = card.querySelector('[data-rir-piece-name]');
    var bits = [name && name.textContent.trim()];
    var col = colourOf(card);
    if (col) bits.push(col.toLowerCase());
    var mark = label(on(card, sd === 'back' ? 'back' : 'front'));
    bits.push(mark ? mark : 'no mark');
    bits.push(sd === 'back' ? 'back' : 'front');
    return bits.filter(Boolean).join(', ');
  }
  // a picture's key in the card's media map: "CODE", "CODE:chest", "CODE:back", "plain", "plain:back" —
  // with the colour in front ("Black|CODE:back") on a card that offers colours
  function key(card, name) {
    var col = colourOf(card);
    return (col ? col + '|' : '') + name;
  }
  function urlFor(card, code, which) {
    var set = media(card)[piece(card)] || {};
    if (which === 'back') return (code && !overlayOf(card, code)) ? (set[key(card, code + ':back')] || set.featured) : set[key(card, 'plain:back')];
    if (!code) return set[key(card, 'plain')];
    return spotOf(card) === 'chest' ? (set[key(card, code + ':chest')] || set[key(card, code)]) : (set[key(card, code)] || set[key(card, code + ':chest')]);
  }
  function pictures(card) {
    var f = on(card, 'front'), b = on(card, 'back');
    var set = media(card)[piece(card)] || {};
    return { front: urlFor(card, f ? f.value : '', 'front') || set.featured, back: urlFor(card, b ? b.value : '', 'back') || set.featured };
  }
  function paint(card) {
    var pics = pictures(card), sd = side(card);
    show(card.querySelector('[data-rir-pic]'), pics[sd], described(card, sd));
    var sideLabel = card.querySelector('[data-rir-pic-side]');
    if (sideLabel) sideLabel.textContent = sd === 'back' ? 'Back' : 'Front';
    show(card.querySelector('[data-rir-thumb="front"]'), at(pics.front, 300), described(card, 'front'));
    show(card.querySelector('[data-rir-thumb="back"]'), at(pics.back, 300), described(card, 'back'));
    warm(pics[sd === 'front' ? 'back' : 'front']);
    // an overlay on the back picture where the print sits — the Raiders name and number, placed from the
    // piece's box (centre x, centre y, width, as % of the picture)
    var b = on(card, 'back');
    var ov = b ? overlayOf(card, b.value) : '';
    var fs = sizesOf(card);
    var box = (fs && fs.getAttribute('data-nnbox') || '').split(',');
    var nnp = card.querySelector('[data-rir-nnp]');
    if (!nnp) return;
    nnp.hidden = !(ov === 'nn' && sd === 'back');
    if (nnp.hidden) return;
    if (box.length === 3) { nnp.style.setProperty('--x', box[0] + '%'); nnp.style.setProperty('--y', box[1] + '%'); nnp.style.setProperty('--w', box[2] + '%'); }
    var nameIn = card.querySelector('[data-rir-nn-name]'), numIn = card.querySelector('[data-rir-nn-num]');
    var nameEl = card.querySelector('[data-rir-nnp-name]'), numEl = card.querySelector('[data-rir-nnp-num]');
    var nameVal = ((nameIn && nameIn.value.trim()) || (nameIn ? nameIn.placeholder : 'NAME')).toUpperCase();
    var numVal = (numIn && numIn.value.trim()) || (numIn ? numIn.placeholder : '0');
    if (nameEl) { nameEl.textContent = nameVal; nameEl.parentNode.setAttribute('font-size', Math.min(13, 92 / (0.72 * Math.max(nameVal.length, 3))).toFixed(1)); }
    if (numEl) numEl.textContent = numVal;
  }

  // the rules. A zip hoodie's front takes the chest marks only (data-front-only), small on the left chest,
  // clear of the zip; on every other piece the spot decides — small on the left chest takes the chest
  // marks (the Raiders heads, the GS monogram — three or four inches, so never centre chest and never
  // the back), centre chest the centre marks (the crests, the wordmarks). The name and number only where
  // the piece has them (Raiders); a tile whose ink doesn't print on the chosen colour is out of sight
  // (GSGE). On both, one design comes with the piece and the variant follows the second one: with a
  // second mark, or with a name and number over a front mark. The price, the two side tabs, the +$15 on
  // the tiles and the ticket say what the order is.
  function applyRules(card) {
    var fs = sizesOf(card);
    var only = fs ? fs.getAttribute('data-front-only') : '';
    var hasNN = !!(fs && fs.getAttribute('data-has-nn') === '1');
    // A garment that takes no back mark takes no nameplate either, whatever variants it carries.
    // The onesie's snaps cross its back. The Hive page has refused this from the placements rules
    // since it was built; this card had no such rule and an order went through with a nameplate on
    // the back of an onesie, which cannot be printed.
    var noBack = !!(fs && fs.getAttribute('data-no-back') === '1');
    if (noBack) hasNN = false;
    var backTab = card.querySelector('[data-rir-side="back"]');
    if (backTab) backTab.hidden = noBack;
    if (noBack) {
      card.querySelectorAll('input[name="back-' + card.id + '"]').forEach(function (r) {
        if (r.checked && r.value) r.checked = false;
      });
      var noneBack = card.querySelector('input[name="back-' + card.id + '"][value=""]');
      if (noneBack) noneBack.checked = true;
      if (backTab && backTab.getAttribute('aria-selected') === 'true') {
        var frontTab = card.querySelector('[data-rir-side="front"]');
        if (frontTab) frontTab.click();
      }
    }
    var col = colourOf(card);
    var chooser = hasSpot(card);
    if (col) card.style.setProperty('--rir-swatch', col === 'White' ? '#ffffff' : '#141414');
    var hint = card.querySelector('[data-rir-hint]');
    if (hint) hint.hidden = !only;
    var spot = card.querySelector('[data-rir-spot]');
    if (spot) spot.hidden = !!only;
    // the inks that print on this colour: bronze on both, white on black, black on white
    function inkOut(r) {
      var ink = r.getAttribute('data-ink');
      return !!(ink && col && (col === 'White' ? ink === 'W' : ink === 'K'));
    }
    card.querySelectorAll('input[name="back-' + card.id + '"]').forEach(function (r) {
      var out = inkOut(r);
      r.closest('.rir__mark').hidden = out;
      r.disabled = out;
      if (out && r.checked) r.checked = false;
    });
    var s = spotOf(card);
    var limit = only ? only.split(',') : null;
    var spotHint = card.querySelector('[data-rir-spot-hint]');
    if (spotHint) spotHint.hidden = !!only || s !== 'chest';
    var centreHint = card.querySelector('[data-rir-centre-hint]');
    if (centreHint) centreHint.hidden = !!only || s !== 'centre';
    card.querySelectorAll('input[name="front-' + card.id + '"]').forEach(function (r) {
      var out = inkOut(r);
      r.closest('.rir__mark').hidden = out;
      var off = out || (r.value !== '' && (limit ? limit.indexOf(r.value) === -1 : (chooser && classOf(r) !== s)));
      r.disabled = off;
      r.closest('.rir__mark').classList.toggle('is-off', off && !out);
      if (off && r.checked) r.checked = false;
    });
    if (!on(card, 'front')) { var fnone = card.querySelector('input[name="front-' + card.id + '"][value=""]'); if (fnone) fnone.checked = true; }
    var f = on(card, 'front');
    var hasFront = !!(f && f.value);
    var tile = card.querySelector('[data-rir-nn-tile]');
    if (tile) {
      var nnRadio = tile.querySelector('input');
      tile.hidden = !hasNN;
      nnRadio.disabled = !hasNN;
      if (!hasNN && nnRadio.checked) nnRadio.checked = false;
    }
    if (!on(card, 'back')) { var bnone = card.querySelector('input[name="back-' + card.id + '"][value=""]'); if (bnone) bnone.checked = true; }
    var b = on(card, 'back');
    var back = b ? b.value : '';
    var nn = back === 'nn';
    var fields = card.querySelector('[data-rir-nn-fields]');
    if (fields) fields.hidden = !nn;
    card.querySelectorAll('[data-rir-nn-name], [data-rir-nn-num]').forEach(function (i) { i.disabled = !nn; });
    // the front shoulder number, where a client offers one
    var fnum = f && f.value === 'SN';
    var numFields = card.querySelector('[data-rir-num-fields]');
    if (numFields) numFields.hidden = !fnum;
    card.querySelectorAll('[data-rir-num]').forEach(function (i) { i.disabled = !fnum; });
    var extra = (hasFront && back && !nn) ? 'm2' : (hasFront && nn) ? 'nn' : 'plain';
    card.querySelectorAll('[data-rir-sizes] input[name="id"]').forEach(function (r) {
      var v = r.getAttribute('data-' + extra) || r.getAttribute('data-plain');
      if (v) r.value = v;
    });
    var base = fs ? fs.getAttribute('data-price-plain') : '';
    var now = (fs && fs.getAttribute('data-price-' + extra)) || base;
    var price = card.querySelector('[data-rir-price]');
    if (price && now) price.textContent = now;
    var where = spotOf(card) === 'chest' ? 'left chest' : 'centre chest';
    var more = money(now) - money(base);
    var plus = more > 0 ? '+ $' + dollars(more) : '';
    // every tile that would be the second design says so: the back's tiles once the front has a mark,
    // the front's once the back has something; the amount is the piece's own
    var step = money(fs && (fs.getAttribute('data-price-m2') || fs.getAttribute('data-price-nn'))) - money(base);
    var stepNN = money(fs && fs.getAttribute('data-price-nn')) - money(base);
    card.querySelectorAll('[data-rir-panel="front"] [data-rir-plus]').forEach(function (el) { el.textContent = '+ $' + dollars(step); el.hidden = !(back && step > 0); });
    card.querySelectorAll('[data-rir-panel="back"] .rir__mark:not([data-rir-nn-tile]) [data-rir-plus]').forEach(function (el) { el.textContent = '+ $' + dollars(step); el.hidden = !(hasFront && step > 0); });
    card.querySelectorAll('[data-rir-nn-tile] [data-rir-plus]').forEach(function (el) { el.textContent = '+ $' + dollars(stepNN); el.hidden = !(hasFront && stepNN > 0); });
    // the tab captions: the mark and where it sits — the full name from 40rem, the code on a phone
    function what(el, long, short, two) {
      if (!el) return;
      el.innerHTML = '<span class="rir__side-long">' + esc(long) + '</span><span class="rir__side-short">' + esc(short) + '</span>' + (two ? '<span>' + esc(two) + '</span>' : '');
    }
    what(card.querySelector('[data-rir-what="front"]'), hasFront ? label(f) : 'Nothing on the front', hasFront ? f.value : 'Nothing yet', hasFront ? where : '');
    what(card.querySelector('[data-rir-what="back"]'), nn ? 'Name & number' : back ? label(b) : 'Nothing on the back', nn ? 'Name & number' : back ? b.value : 'Nothing yet', back ? (plus ? 'upper back · ' + plus : 'upper back') : '');
    ticket(card, { f: f, b: b, hasFront: hasFront, back: back, nn: nn, where: where, base: base, now: now, plus: plus, colour: col });
    paint(card);
  }
  // the ticket by the button: the piece (its colour, its size), then a row for each side that has something
  // on it — the first design included, the second at its extra — each with a Remove, and the price for one
  function ticket(card, o) {
    var el = card.querySelector('[data-rir-summary]');
    if (!el) return;
    function row(k, v, p, clear, cls) {
      return '<div class="rir__ticket-row' + (cls ? ' ' + cls : '') + '"><span class="rir__ticket-k">' + k + '</span><span class="rir__ticket-v">' + v + '</span><span class="rir__ticket-p">' + p + '</span>' +
        (clear ? '<button class="rir__ticket-x" type="button" data-rir-clear="' + clear + '">Remove</button>' : '<span class="rir__ticket-x"></span>') + '</div>';
    }
    var chip = card.querySelector('[data-rir-piece]:checked');
    var name = chip ? chip.getAttribute('data-name') : ((card.querySelector('.rir__name') || {}).textContent || '');
    var sizeOn = card.querySelector('[data-rir-sizes]:not([hidden]) input[name="id"]:checked');
    var sizeBtn = sizeOn && sizeOn.parentNode.querySelector('.rir__chip-btn');
    var size = sizeBtn ? sizeBtn.textContent.trim() : '';
    var rows = [row('Piece', esc(name) + (o.colour ? ' · ' + esc(o.colour) : '') + ' · ' + (size ? esc(size) : '<em>pick a size</em>'), esc(o.base || ''), null)];
    var both = o.hasFront && o.back;
    if (o.hasFront) rows.push(row('Front', esc(label(o.f)) + ' · ' + o.where, 'included', 'front'));
    if (o.nn) {
      var nameIn = card.querySelector('[data-rir-nn-name]'), numIn = card.querySelector('[data-rir-nn-num]');
      var typed = ((nameIn && nameIn.value.trim().toUpperCase()) || '') + ' ' + ((numIn && numIn.value.trim()) || '');
      rows.push(row('Back', 'Name &amp; number' + (typed.trim() ? ' · ' + esc(typed.trim()) : ''), both ? esc(o.plus) : 'included', 'back'));
    } else if (o.back) {
      rows.push(row('Back', esc(label(o.b)) + ' · upper back', both ? esc(o.plus) : 'included', 'back'));
    }
    if (!o.hasFront && !o.back) rows.push('<div class="rir__ticket-row rir__ticket-row--empty">No mark yet. Pick one for the front, the back, or both.</div>');
    rows.push(row('Each', '', esc(o.now || ''), null, 'rir__ticket-row--total'));
    el.innerHTML = rows.join('');
  }
  function setSide(card, name) {
    card._rirSide = name;
    card.querySelectorAll('[data-rir-side]').forEach(function (t) {
      var is = t.getAttribute('data-rir-side') === name;
      t.classList.toggle('is-on', is);
      t.setAttribute('aria-selected', is ? 'true' : 'false');
    });
    card.querySelectorAll('[data-rir-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-rir-panel') !== name; });
    paint(card);
  }
  // the size chips of the piece (and colour) in hand are live; every other size fieldset is parked — its
  // radios disabled and unchecked — so one form posts one variant
  function activateSizes(card) {
    var pc = piece(card), col = colourOf(card);
    card.querySelectorAll('[data-rir-sizes]').forEach(function (fs) {
      var is = fs.getAttribute('data-piece') === pc && (!fs.hasAttribute('data-colour') || !col || fs.getAttribute('data-colour') === col);
      fs.hidden = !is;
      fs.querySelectorAll('input[name="id"]').forEach(function (r) {
        if (is) { if (r.hasAttribute('data-rir-parked')) { r.disabled = false; r.removeAttribute('data-rir-parked'); } }
        else { if (!r.disabled) { r.disabled = true; r.setAttribute('data-rir-parked', ''); } r.checked = false; }
      });
    });
  }
  function switchPiece(card, input) {
    // the colours this piece comes in: the chips it lacks go out of sight, and the choice moves to one it has
    var cols = (input.getAttribute('data-colours') || '').split(',').filter(Boolean);
    var chips = card.querySelectorAll('[data-rir-colour]');
    if (chips.length && cols.length) {
      var checked = null;
      chips.forEach(function (c) {
        var has = cols.indexOf(c.value) !== -1;
        c.closest('.rir__chip').hidden = !has;
        c.disabled = !has;
        if (!has && c.checked) c.checked = false;
        if (has && c.checked) checked = c;
      });
      if (!checked) { var first = card.querySelector('[data-rir-colour]:not(:disabled)'); if (first) first.checked = true; }
      var cf = card.querySelector('[data-rir-colours]');
      if (cf) cf.classList.toggle('is-one', cols.length < 2);
    }
    activateSizes(card);
    card.querySelectorAll('[data-rir-about]').forEach(function (b) { b.hidden = b.getAttribute('data-rir-about') !== input.value; });
    document.querySelectorAll('#compare-' + card.id + ' [data-rir-cmp]').forEach(function (c) { c.classList.toggle('is-here', c.getAttribute('data-rir-cmp') === input.value); });
    var name = card.querySelector('[data-rir-piece-name]');
    if (name && input.getAttribute('data-name')) name.textContent = input.getAttribute('data-name');
    applyRules(card);
  }
  document.querySelectorAll('[data-rir-card]').forEach(function (card) {
    var pc = card.querySelector('[data-rir-piece]:checked');
    if (pc) switchPiece(card, pc); else applyRules(card);
  });

  document.addEventListener('click', function (e) {
    var pick = e.target.closest('[data-rir-choose]');
    if (pick) {
      var card = document.getElementById(pick.getAttribute('data-rir-for')) || pick.closest('[data-rir-card]');
      var radio = card && card.querySelector('[data-rir-piece][value="' + pick.getAttribute('data-rir-choose') + '"]');
      if (radio && !radio.checked) { radio.checked = true; switchPiece(card, radio); }
      return;
    }
    var tab = e.target.closest('[data-rir-side]');
    if (tab) { setSide(tab.closest('[data-rir-card]'), tab.getAttribute('data-rir-side')); return; }
    var clear = e.target.closest('[data-rir-clear]');
    if (clear) {
      var cc = clear.closest('[data-rir-card]');
      var none = cc.querySelector('input[name="' + clear.getAttribute('data-rir-clear') + '-' + cc.id + '"][value=""]');
      if (none) none.checked = true;
      applyRules(cc);
      return;
    }
    var step = e.target.closest('[data-rir-qty]');
    if (step) {
      var input = step.parentNode.querySelector('[data-rir-qty-in]');
      input.value = Math.max(1, Math.min(20, (Number(input.value) || 1) + Number(step.getAttribute('data-rir-qty'))));
    }
  });

  document.addEventListener('change', function (e) {
    var form = e.target.closest('[data-rir-form]');
    if (!form) return;
    var card = form.closest('[data-rir-card]');
    var err = form.querySelector('[data-rir-err]');
    if (err) err.hidden = true;
    var n = e.target.name || '';
    if (e.target.hasAttribute('data-rir-piece')) switchPiece(card, e.target);
    else if (e.target.hasAttribute('data-rir-colour')) { activateSizes(card); applyRules(card); }
    else if (n === 'front-' + card.id || n === 'back-' + card.id || n === 'spot-' + card.id || n === 'id') applyRules(card);
    else if (e.target.hasAttribute('data-rir-qty-in')) e.target.value = Math.max(1, Math.min(20, Number(e.target.value) || 1));
  });
  document.addEventListener('input', function (e) {
    if (e.target.hasAttribute('data-rir-nn-name') || e.target.hasAttribute('data-rir-nn-num') || e.target.hasAttribute('data-rir-num')) applyRules(e.target.closest('[data-rir-card]'));
  });
  // a mark's picture is fetched as the pointer (or focus) reaches its tile, so choosing it shows at once
  function warmTile(e) {
    var tile = e.target.closest('.rir__mark');
    if (!tile) return;
    var card = tile.closest('[data-rir-card]'), r = tile.querySelector('input'), panel = tile.closest('[data-rir-panel]');
    if (card && r) warm(urlFor(card, r.value, panel ? panel.getAttribute('data-rir-panel') : 'front'));
  }
  document.addEventListener('mouseover', warmTile);
  document.addEventListener('focusin', warmTile);

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-rir-form]');
    if (!form) return;
    e.preventDefault();
    var card = form.closest('[data-rir-card]');
    var err = form.querySelector('[data-rir-err]');
    var btn = form.querySelector('[data-rir-add]');
    var size = form.querySelector('input[name="id"]:checked');
    var f = on(card, 'front'), b = on(card, 'back');
    var hasFront = !!(f && f.value), back = b ? b.value : '';
    function say(msg, row) { err.textContent = msg; err.hidden = false; nudge(row); }
    if (!size) { say('Pick a size first.', form.querySelector('[data-rir-sizes]:not([hidden])')); return; }
    if (!hasFront && !back) { say('Pick a mark for the front, the back, or both.', form.querySelector('[data-rir-marks]')); return; }
    // a card on the Hive page is a real store to try, with the checkout off
    if (card.closest('[data-rir-demo-wrap]')) { say("That's the whole order. On a store of your own, this puts it in the cart.", null); return; }
    var props = {};
    if (hasFront) props['Front mark'] = f.value + ' · ' + label(f) + ' · ' + (spotOf(card) === 'chest' ? 'left chest' : 'centre chest');
    if (hasFront && f.value === 'SN') {
      var shNum = form.querySelector('[data-rir-num]');
      var shVal = shNum ? shNum.value.trim() : '';
      if (!/^[0-9]{1,2}$/.test(shVal)) { say('The shoulder number is one or two digits, 0 to 99.', form.querySelector('[data-rir-num-fields]')); shNum && shNum.focus(); return; }
      props['Front mark'] = 'SN · shoulder number · left shoulder';
      props['Shoulder number'] = shVal;
    }
    if (back && back !== 'nn') props['Back mark'] = b.value + ' · ' + label(b);
    if (back === 'nn') {
      var nnName = form.querySelector('[data-rir-nn-name]'), nnNum = form.querySelector('[data-rir-nn-num]');
      var nameVal = nnName ? nnName.value.trim().toUpperCase() : '', numVal = nnNum ? nnNum.value.trim() : '';
      if (!nameVal) { say('Type the name for the back, or pick something else for the back.', form.querySelector('[data-rir-nn-fields]')); nnName && nnName.focus(); return; }
      if (!/^[0-9]{1,2}$/.test(numVal)) { say('The number is one or two digits, 0 to 99.', form.querySelector('[data-rir-nn-fields]')); nnNum && nnNum.focus(); return; }
      props['Back name'] = nameVal;
      props['Number'] = numVal;
    }
    err.hidden = true;
    var qtyIn = form.querySelector('[data-rir-qty-in]');
    var qty = Math.max(1, Math.min(20, Number(qtyIn && qtyIn.value) || 1));
    btn.disabled = true;
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(size.value), quantity: qty, properties: props }], sections: 'cart-drawer' })
    }).then(function (r) { return r.json(); }).then(function (data) {
      btn.disabled = false;
      if (data.status || data.message) { say(data.description || data.message, null); return; }
      var drawer = document.getElementById('cart-drawer');
      if (data.sections && data.sections['cart-drawer'] && drawer) {
        var tmp = document.createElement('div');
        tmp.innerHTML = data.sections['cart-drawer'];
        var fresh = tmp.querySelector('#cart-drawer');
        if (fresh) drawer.innerHTML = fresh.innerHTML;
      }
      document.dispatchEvent(new CustomEvent('cart:updated'));
      var opener = document.querySelector('[data-open="cart-drawer"]');
      if (opener) opener.click();
      btn.classList.add('is-done'); btn.textContent = 'Added';
      setTimeout(function () { btn.classList.remove('is-done'); btn.textContent = 'Add to cart'; }, 1800);
    }).catch(function () { btn.disabled = false; say("Couldn't add that just now. Try again?", null); });
  });
})();
